import {
  Typography,
  styled,
  Grid,
  TableRow,
  TableCell,
  Button,
  Dialog,
  Box,
  IconButton,
  ButtonBase,
  TooltipProps,
  Tooltip,
  tooltipClasses,
} from '@mui/material';

import { BackButton } from '../../../../../components/UI/Button';

export const CustomBackButton = styled(BackButton)(() => ({
  margin: '-20px 0 -10px -30px',
}));

export const GridSection = styled(Grid)(({ theme }) => ({
  background: '#FFFFFE',
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: 20,
  padding: '40px',
  [theme.breakpoints.down('xxl')]: {
    padding: '32px',
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  color: theme.palette.common.grey,
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '500',
  fontSize: '16px',
  marginRight: 8,
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: 8,
  marginTop: '28px',
  [theme.breakpoints.down('xl')]: {
    marginTop: '20px',
  },
}));

export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  color: theme.palette.secondary.main,
  font: '600 21px Montserrat',
  backgroundColor: '#F1F5FA',
  verticalAlign: 'middle',
  padding: '20px 16px',
  '& span': {
    verticalAlign: 'bottom',
    paddingLeft: '4px',
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '16px',
    '& span': {
      fontSize: '18px',
    },
  },
}));

export const StyledCell = styled(TableCell)(() => ({
  color: '#707070',
  padding: '20px',
  fontSize: '16px',
}));

export const StatusCell = styled(TableCell)(() => ({
  padding: '20px',
  fontSize: '16px',
  fontWeight: '600',
}));

export const ButtonsWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '20px',
  justifyContent: 'center',
}));

export const StyledRow = styled(TableRow)(() => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#F1F5FA66',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  maxWidth: '140px',
  height: '40px',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '800px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  minWidth: 700,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const TextTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  span: {
    color: theme.palette.secondary.main,
  },
}));

export const DownloadButton = styled(IconButton)(({ theme }) => ({
  span: {
    color: theme.palette.primary.main,
  },
  '&:disabled': {
    span: {
      filter: 'opacity(45%)',
    },
  },
}));

export const ActionButton = styled(ButtonBase)(({ theme }) => ({
  color: theme.palette.primary.main,
  textAlign: 'justify',
  fontSize: '16px',
  span: {
    width: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '&:disabled': {
    span: {
      filter: 'opacity(45%)',
    },
  },
}));

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    textAlign: 'justify',
    fontSize: '12px',
    padding: '8px',
    fontWeight: 'normal',
    border: '1px solid #dadde9',
    boxShadow: '0px 3px 6px #00000029',
    marginTop: '8px !important',
  },
}));

export const CloseButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '20px 20px -50px 0',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));
